/**
 * StorefrontTabs — Products/Menu · About · Photos · Reviews.
 * Label for the primary tab is derived from business type:
 *   - Restaurant / Cafe / Food / Bakery → "Menu"
 *   - Services / Salon / Barber-ish     → "Services"
 *   - Everything else                   → "Products"
 */
const FOOD_KEYWORDS = ["restaurant", "cafe", "food", "bakery", "eatery", "diner", "kitchen", "grill", "bbq", "juice", "coffee"];
const SERVICE_KEYWORDS = ["salon", "spa", "barber", "consulting", "coaching", "cleaning", "photography", "service"];

export function primaryTabLabelFor(business) {
  const raw = `${business?.category || ""} ${business?.custom_category || ""}`.toLowerCase();
  if (FOOD_KEYWORDS.some((k) => raw.includes(k))) return "Menu";
  if (SERVICE_KEYWORDS.some((k) => raw.includes(k))) return "Services";
  return "Products";
}

export function StorefrontTabs({ business, active, onChange, hasPhotos = false, reviewCount = 0 }) {
  const primary = primaryTabLabelFor(business);
  const tabs = [
    { key: "products", label: primary },
    { key: "about", label: "About" },
    ...(hasPhotos ? [{ key: "photos", label: "Photos" }] : []),
    { key: "reviews", label: `Reviews${reviewCount ? ` (${reviewCount})` : ""}` },
  ];

  return (
    <nav
      role="tablist"
      aria-label="Storefront sections"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 mb-4"
      data-testid="storefront-tabs"
    >
      <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto no-scrollbar border-b border-gray-100">
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(t.key)}
              data-testid={`storefront-tab-${t.key}`}
              className={
                "relative px-3 sm:px-4 py-3 text-sm font-medium font-body whitespace-nowrap transition-colors " +
                (isActive ? "text-tbc-navy" : "text-gray-500 hover:text-tbc-navy")
              }
            >
              {t.label}
              {isActive && (
                <span className="absolute inset-x-2 -bottom-px h-0.5 bg-tbc-gold rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default StorefrontTabs;
